import { useEffect, useState } from 'react';
import { adminApi } from '@formosa/shared/api/admin';

export default function TransferModal({ sessionId, open, onClose, onTransferred }) {
  const [keyword, setKeyword] = useState('');
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(null);

  async function load(kw = keyword) {
    if (!sessionId) return;
    setLoading(true);
    setError('');
    try {
      const data = await adminApi.imCsTransferCandidates(sessionId, {
        keyword: kw || undefined,
        limit: 30,
      });
      setCandidates(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err.message || '載入候選人失敗');
      setCandidates([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (open) load('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, sessionId]);

  if (!open) return null;

  async function transferTo(agentAdminId) {
    // Keep snowflake IDs as string — Number() loses precision above 2^53-1
    const targetId = agentAdminId == null ? null : String(agentAdminId);
    setSubmitting(targetId);
    setError('');
    try {
      await adminApi.imCsCreateTransfer(sessionId, { targetAgentAdminId: targetId });
      onTransferred?.();
      onClose();
    } catch (err) {
      setError(err.message || '轉接失敗');
    } finally {
      setSubmitting(null);
    }
  }

  return (
    <div className="cs-modal-backdrop" onClick={onClose}>
      <div className="cs-modal" onClick={(e) => e.stopPropagation()}>
        <h3>轉接客服</h3>
        <div style={{ display: 'flex', gap: 8 }}>
          <input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜尋客服"
            style={{ flex: 1 }}
          />
          <button type="button" className="btn btn-secondary btn-sm" onClick={() => load(keyword)}>
            搜尋
          </button>
        </div>
        {error ? <div className="cs-error">{error}</div> : null}
        {loading ? <div className="cs-hint">載入中…</div> : null}
        <div className="cs-modal__list">
          {candidates.map((c) => (
            <div key={c.adminUserId || c.agentId} className="cs-modal__row">
              <div>
                <div>{c.displayName || c.username || c.adminUserId}</div>
                <div className="cs-list-item__meta">
                  {c.presenceStatus || '—'}
                  {c.eligible === false ? ' · 不合格' : ''}
                  {c.currentActiveSessions != null
                    ? ` · ${c.currentActiveSessions}/${c.maxConcurrentSessions ?? '—'}`
                    : ''}
                </div>
              </div>
              <button
                type="button"
                className="btn btn-primary btn-sm"
                disabled={c.eligible === false || submitting === (c.adminUserId || c.agentId)}
                onClick={() => transferTo(c.adminUserId || c.agentId)}
              >
                轉接
              </button>
            </div>
          ))}
          {!loading && !candidates.length ? <div className="cs-empty">無候選人</div> : null}
        </div>
        <button type="button" className="btn btn-secondary" onClick={onClose}>關閉</button>
      </div>
    </div>
  );
}
